import { useBackend } from "../../services";
import { useEffect, useState } from "react";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { toast } from "react-toastify";
import { DataStorage } from "../../models/DataStorage";

export const useGetCountries = <T>(
  setLoading: (loading: boolean) => void,
  dependencies: T[] = []
) => {
  const { get } = useBackend();
  const storage = DataStorage.countriesStorage;
  const [countries, setCountries] = useState(storage.getData(false, ""));
  useEffect(() => {
    if (countries && countries.length > 0) return;
    setLoading(true);
    get("countries").then(({ body, status }) => {
      if (StatusCodesHelper.isSuccessful(status)) {
        setCountries(body);
        storage.setData(body, false, "");
      } else if (!StatusCodesHelper.isSessionExpired(status)) {
        toast.error(body.message);
      }
      setLoading(false);
    });
  }, dependencies);
  return countries;
};
